import Klarna from './Klarna';
import CartHelper from './CartHelper';
import TicketInsurance from './TicketInsurance'

export default class Cart {
    
    constructor() {
        this.el = $('.cart');
        this.klarna = new Klarna();
        this.klarna.enable();
        this.ticketInsurance = new TicketInsurance();
        this.ticketInsurance.initEnableTicketInsurance();
        
        

        if (!this.el.length) {
            return false;
        }
        this.onToggleDetails = this.onToggleDetails.bind(this);
        this.submitform = this.submitform.bind(this);
        this.current = null;
        this.init();

        document.addEventListener("cartUpdateEvent", () => {
            this.el.load('/cart/GetCartInMenu');
        });
    }

    init() {
        const context = this;
        this.el.find('.details').each(function () {
            new TicketsDetails({ el: $(this), onToggleDetails: context.onToggleDetails });
        });

        $('#showpaymentform input:not(type[submit])').on('keyup', this.validateform);
        $('#btnShowPayment_submit').on('click', this.submitform);
        subscriptionCart();
        initHandlers();
    }

    onToggleDetails(td) {

        if (this.current && this.current !== td) {
            this.current.close();
        }

        td.toggle();
        this.current = td;
    }


    submitform() {
        if (this.validateform()) {
            $('#showpaymentform').submit();
        } else {
            $('#showpaymentform input').removeClass("empty");
            return false;
        }
    }

    validateform() {
        let showpaymentform = document.getElementById('showpaymentform');
        if (!showpaymentform) return;
        let isIE = !!document.documentMode;
        if (isIE || showpaymentform.reportValidity()) {
            $("#btnShowPayment_submit").removeClass("disabled");
            $('input[required]').removeClass("empty");

            $('input[pattern]').each(function () {
                $('#' + this.id + '-invalid').hide();
            });

            return true;
        } else {
            $('input[required]').each(function () {
                if ($.trim($(this).val()).length > 0) {
                    $(this).removeClass("empty");
                }
            });

            $('input[pattern]').each(function () {
                var pattern = $(this).attr('pattern');
                var exp = new RegExp('^' + pattern + '$');

                if (exp.test($(this).val())) {
                    $('#' + this.id + '-invalid').hide();
                }
                else {
                    $('#' + this.id + '-invalid').show();
                }
            });
            return false;
        }
    }
}

function initHandlers() {
    const cartContinueButton = document.getElementById("cartContinue");
    const certificateCodeButton = document.getElementById("certificateCode");
    const popUpButton = document.getElementById("popUpButton");
    const linkingSuccessModal = document.getElementById("linkingSuccessModal");
    const membershipVerifyModal = document.getElementById("membershipVerifyModal");
    if (membershipVerifyModal) {
        $("#membershipVerifyModal").modal('show');
    }
    const externalLoginVerifyModal = document.getElementById("externalLoginVerifyModal");
    if (externalLoginVerifyModal) {
        $("#externalLoginVerifyModal").modal('show');
    }
    if (cartContinueButton) {
        cartContinueButton.onclick = getCartContinueHandler;
    }

    if (certificateCodeButton) {
        certificateCodeButton.onclick = getCertificateCodeHandler;
    }

    if (popUpButton) {
        window.onload = function() {
            popUpButton.click();
        }
    }

    if (linkingSuccessModal) {
        window.onload = function() {
            $("#linkingSuccessModal").modal('show');
        }
    }
}

function getCartContinueHandler() {
    document.getElementById("cartContinue").disabled = true;

    const cartIndexViewModel = CartHelper.populateCartIndexViewModel();

    $.ajax({
        url: "/Cart/Index",
        dataType: "json",
        type: "POST",
        data: { model: cartIndexViewModel },
        success: function (data) {
            window.location.href = data.url;
        }
    });
}

function getCertificateCodeHandler() {
    const cartIndexViewModel = CartHelper.populateCartIndexViewModel();

    $.ajax({
        url: "/Cart/ValidateCertificatePayment",
        dataType: "json",
        type: "POST",
        data: { model: cartIndexViewModel },
        success: function (data) {
            window.location.href = data.url;
        }
    });
}

function subscriptionCart() {
    if ($("main").hasClass('subscription-cart')) {
        //disable desktop-menu
        $('.desktop-header').find('.desktop-header-inner').children().not('.logo').empty();
        //disable mobile-menu
        $(".mobile-header").find(".row").css('height', '50px');
        $(".mobile-header").find(".row").empty();
        $('.mobile-menu').remove();

        //USED FOR CHECK BOX THAT MIGHT BE INCLUDED IN THE FUTURE
        //$("#showpaymentform").hide();
        //$("#checkbox-show-payment-form").click(function () {
        //    if ($(this).is(":checked")) {
        //        $("#showpaymentform").show(300);
        //    } else {
        //        $("#showpaymentform").hide(200);
        //    }
        //});

    }
}

class TicketsDetails {

    constructor(props) {
        this.el = props.el;
        this.props = props;
        this.open = false;
        this.init();
    }

    init() {
        this.detailsBody = this.el.find('.details-body');
        this.toggleDetailsLink = this.el.find('.toggle-details a');
        this.arrow = this.toggleDetailsLink;
        const context = this;
        this.toggleDetailsLink.on('click', () => {
            context.props.onToggleDetails(context);
            return false;
        });
        this.open = this.arrow.hasClass("open");

    }

    toggle() {
        this.open ? this.detailsBody.hide() && this.arrow.removeClass('open') : this.detailsBody.show() && this.arrow.addClass('open');
        this.open = !this.open;
    }

    close() {
        this.detailsBody.hide() && this.arrow.removeClass('open');
        this.open = false;
    }
}